import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Box, Typography } from "@mui/material";
import { useLoaderContext, useToastContext } from '../../../../Context/ToastContext';
import styles from "./UpdatePassword.module.css";
import navbarLogoDesktop from '../../../../images/logo_loginscreen.png';
import navbarLogoMobile from '../../../../images/login_mobile.png';
import { apiPost } from "../../../../utils/ApiManager";

const handlepassword = process.env.REACT_APP_HANDLE_PASSWORD_VERIFY_OTP

function UpdatePassword() {
  const location = useLocation();  // Get the location object

  const [formData, setFormData] = useState({
    otp: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [errors, setErrors] = useState({
    otp: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [isFormValid, setIsFormValid] = useState(false);
  const { showToast } = useToastContext();
  const { setLoading } = useLoaderContext();
  const navigate = useNavigate();
  const otpInputRef = useRef([]);

  const validateNewPassword = (newpassword) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/;
    return passwordRegex.test(newpassword);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update formData state
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    const newErrors = { ...errors };

    // Validate new password
    if (name === 'newPassword') {
      newErrors.newPassword = validateNewPassword(value)
        ? ''
        : 'Password must start with a capital letter, must contain a symbol, a number & consist of 8 characters.';
    }

    // Validate confirm new password
    if (name === 'confirmNewPassword') {
      // Check if the confirm password matches new password
      if (value !== formData.newPassword) {
        newErrors.confirmNewPassword = 'Passwords do not match';
      }
      else {
        newErrors.confirmNewPassword = '';
      }
    }

    setErrors(newErrors);
  };

  useEffect(() => {
    const isValid =
      formData.otp !== "" &&
      validateNewPassword(formData.newPassword) && // New password must be valid
      validateNewPassword(formData.confirmNewPassword) && // Confirm password must be valid
      formData.newPassword === formData.confirmNewPassword; // Passwords must match

    setIsFormValid(isValid);
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset errors
    setErrors({
      otp: "",
      newPassword: "",
      confirmNewPassword: "",
    });

    const formDataWithUsername = {
      ...formData,
      username: location.state.username,

      // username: formData.username,
    };

    try {
      setLoading(true);
      const response = await apiPost(handlepassword, formDataWithUsername);
      const data = response;
      if (data?.success) {
        showToast(data?.message || "Success!", "success");
        navigate("/");
      } else {
        showToast(data?.message || "Something went wrong!", "error");
      }
    } catch (error) {
      showToast(error?.response?.message || error?.message || "Something went wrong!", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.main}>
        <Box className={styles.leftContainer}>
          <img src={navbarLogoDesktop} className={`${styles.navbarLogo} ${styles.desktopLogo}`} alt="desktop logo" />
          <img src={navbarLogoMobile} className={`${styles.navbarLogo} ${styles.mobileLogo}`} alt="mobile logo" />
          <h1>Your Taste, Our Promise.</h1>
        </Box>

        <div className={styles.rightContainer}>
          <Typography variant="h5" sx={{ color: 'black' }} className={styles.rightContainerTitle}>
            Update Password
          </Typography>
          <form className={styles.UpdatePasswordForm} onSubmit={handleSubmit} noValidate>
            <div className={styles.loginGroup}>
              <label htmlFor="otp">Enter OTP</label>
              <div className={styles.otpContainer}>
                {Array.from({ length: 6 }).map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength={1}
                    ref={(el) => (otpInputRef.current[index] = el)}
                    className={styles.otpInput}
                    value={formData.otp[index] || ""}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      const newOtp = formData.otp.split("");
                      newOtp[index] = value;

                      setFormData((prev) => ({
                        ...prev,
                        otp: newOtp.join(""),
                      }));

                      if (value && index < 5) {
                        otpInputRef.current[index + 1]?.focus();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" && !formData.otp[index] && index > 0) {
                        otpInputRef.current[index - 1]?.focus();
                      }
                    }}
                  />
                ))}
              </div>
            </div>

            <div className={styles.loginGroup}>
              <label>New Password</label>
              <input
                type="password"
                id="newPassword"
                placeholder="New Password"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
              />
              {errors.newPassword && (
                <span className={styles.error}>{errors.newPassword}</span>
              )}
            </div>
            <div className={styles.loginGroup}>
              <label>Confirm New Password</label>
              <input
                type="password"
                id="confirmNewPassword"
                placeholder="Confirm New Password"
                name="confirmNewPassword"
                value={formData.confirmNewPassword}
                onChange={handleChange}
              />
              {errors.confirmNewPassword && (
                <span className={styles.error}>{errors.confirmNewPassword}</span>
              )}
            </div>

            <div className={styles.loginGroup}>
              <Button sx={{ backgroundColor: '#207d46' }} variant="contained" type="submit" className={styles.btnUpdate} disabled={!isFormValid}>
                Update Password
              </Button>
            </div>
          </form>
        </div>
      </div>
      {/* <div className={styles.footer}>
        <p>Copyright © {new Date().getFullYear()} DiNEST. All rights reserved.</p>
      </div> */}
    </div>
  );
}

export default UpdatePassword;
